import React, { PureComponent } from 'react';
import Modal from '../../../../../components/Modal';
import { Form, FormGroup, FormError } from '../../../../../components/Forms/Forms';
import { Select, Input } from '../../../../../components/Forms/fields/index';
import rules from '../../../../../components/Forms/rules';
import enums from '../../../../../constants/enums';
import config from '../../../../../../../config';

class ReleaseModalView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      formState: {
        data: {
          payments: {},
        },
      },
    };
    this.onFormUpdate = this.onFormUpdate.bind(this);
    this.maxValue = this.maxValue.bind(this);
  }
  onFormUpdate(formState) {
    this.setState({
      formState,
    });
  }
  maxValue(value) {
    const { trade } = this.props;
    if (parseFloat(value) > trade.amount) {
      return 'Value can\'t exceed the value of the trade';
    }
  }
  render() {
    const {
      trade,
      toggleReleaseModal,
      releaseModalActive,
      releaseFunds,
      needToRedeem,
      rankedAccounts,
    } = this.props;

    const giftcardOptions = enums.giftcardsMap[trade.type] || {};
    const type = giftcardOptions.releaseModal;
    // this is for if we sold the card before the trade was closed
    // const hasSoldPayment = !!trade.payments.find(payment => payment.status === 'sold');
    const hasSoldPayment = true;

    return (
      <Modal
        className="modal-container release-modal"
        active={releaseModalActive}
        onClose={() => toggleReleaseModal(false)}
      >
        <div>
          <h5>What did you do with the gift card?</h5>
          <ul>
            <li className="redeemed">
              <Form
                state={this.state.formState}
                onChange={this.onFormUpdate}
                onSubmit={(formState) => {
                  releaseFunds({
                    cardAction: 'redeemed',
                    releaseType: type,
                    ...formState.data,
                  });
                }}
              >
                {trade.payments.map((payment, index) => (
                  <div key={index}>
                    <hr/>
                    <h5>{payment.code} - ${payment.value}</h5>
                    {type === 'amazon' ? (
                      <div>
                        {rankedAccounts ? (
                          <div>
                            <FormGroup>
                              <Select name={`payments.${payment.code}.account`} options={rankedAccounts.filter(account => !account.deactivated)} selectLabel="...account" validate={[rules.required()]}/>
                              <FormError/>
                            </FormGroup>
                            <button className="button" type="submit">Redeemed to account</button>
                          </div>
                        ) : (
                          <span>loading...</span>
                        )}
                      </div>
                    ) : (
                      <div>
                        <FormGroup>
                          <label>order #</label>
                          <Input name={`payments.${payment.code}.orderNumber`} type="text" validate={[rules.required()]}/>
                          <FormError/>
                        </FormGroup>
                        <FormGroup>
                          <label>Balance Used</label>
                          <Input name={`payments.${payment.code}.value`} type="number" validate={[rules.required()]}/>
                          <FormError/>
                        </FormGroup>
                        <FormGroup>
                          <label>Email</label>
                          <Input name={`payments.${payment.code}.email`} type="text" validate={[rules.email, rules.required()]}/>
                          <FormError/>
                        </FormGroup>
                        <button className="button" type="submit">Using To Cancel</button>
                      </div>
                    )}
                  </div>
                ))}
              </Form>

              {type === 'amazon' && rankedAccounts && (
                <div className="currentBalances">
                  <h5>Current Balances</h5>
                  <table className="amazonBalances">
                    <thead>
                      <tr>
                        <th>Account Name</th>
                        <th>Username</th>
                        <th>Balance</th>
                        <th>Day</th>
                        <th>Last Updated</th>
                        {config.showStrategy && (
                        <th>Strategy</th>
                      )}
                      </tr>
                    </thead>
                    <tbody>
                      {rankedAccounts.map((amazonBalance, i) => (

                        <tr key={i}>
                          <td>{amazonBalance.originalLabel}</td>
                          <td>{amazonBalance.value}</td>
                          <td>{amazonBalance.balanceString}</td>
                          <td>${amazonBalance.redeemedDay || 0}</td>
                          <td>{amazonBalance.dateString}</td>
                          {config.showStrategy && (
                          <th>{amazonBalance.strategy}</th>
                        )}
                        </tr>
                    ))}
                    </tbody>
                  </table>
                </div>
              )}
            </li>
            <li className="divider">
              OR
            </li>
            {!needToRedeem && type === 'amazon' && (
              <li className="not-verified">
                <button
                  onClick={() => releaseFunds({ cardAction: 'unverified' })}
                  className="button secondary"
                >
                  Did not verify and kept card
                </button>
              </li>
            )}
            {hasSoldPayment && type === 'amazon' && (
              <li className="not-verified">
                <button
                  onClick={() => releaseFunds({ cardAction: 'alreadySold' })}
                  className="button secondary"
                >
                  Already Sold on Paxful
                </button>
              </li>
            )}
            {type !== 'amazon' && (
              <li className="not-verified">
                <button
                  onClick={() => releaseFunds({ cardAction: 'hold' })}
                  className="button secondary"
                >
                  Verified Card, did NOT "use to cancel"
                </button>
              </li>
            )}
          </ul>
        </div>
      </Modal>
    );
  }
}

export default ReleaseModalView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/ReleaseModal/ReleaseModal.view.js